import { render, staticRenderFns } from "./SearchHeaderNameAcademicGroup.vue?vue&type=template&id=d7106b2a"
import script from "./SearchHeaderNameAcademicGroup.vue?vue&type=script&lang=js"
export * from "./SearchHeaderNameAcademicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports